<template>
  <div class="app-container">
    <div class="content-wrapper">
      <div class="qr-section">
        <div class="qr-card">
          <h3>扫码访问微信小程序</h3>
          <div class="qr-code">
            <img :src="appData.qrCode" alt="小程序二维码">
          </div>
          <p class="qr-tip">强烈推荐你以该方式起始使用</p>
        </div>
      </div>
    </div>
    <!-- 底部版权信息 -->
    <div class="footer">
      <p class="copyright">
        Copyright © 2017-2025 XboxFan.com
      </p>
      <p class="icp">
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">{{ beian }}</a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppView',
  data() {
    return {
      appData: {
        qrCode: require('@/assets/app/download-page/qr-code.jpg'),
      },
      beian: '晋ICP备20001973号-3'
    }
  },
  mounted() {
    window.document.title = 'Xbox比价助手';
  },
}
</script>

<style scoped>
.app-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px;
}

.content-wrapper {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.qr-section {
  display: flex;
  justify-content: center;
  align-items: center;
}

.qr-card {
  background: white;
  border-radius: 20px;
  padding: 40px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  width: 300px;
}

.qr-card h3 {
  margin: 0 0 20px 0;
  font-size: 20px;
  color: #333;
}

.qr-code {
  margin: 20px 0;
}

.qr-code img {
  width: 200px;
  height: 200px;
}

.qr-tip {
  color: #666;
  font-size: 16px;
  margin: 20px 0 0 0;
}

.footer {
  text-align: center;
  padding: 15px;
  color: #666;
  font-size: 13px;
  line-height: 1.6;
  margin-top: 20px;
  margin-bottom: 20px;
}

.copyright, .icp {
  margin: 4px 0;
}

.footer a {
  color: #818CE1;
  text-decoration: none;
  transition: color 0.3s;
}

.footer a:hover {
  color: #6c78d9;
}
</style>
